// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ios.platform-cordova .jackpot-counter {
  border-radius: 4px 4px 0 0;
  line-height: 0.5rem;
  padding: 0 1px 2px;
}
.ios.platform-cordova .jackpot-counter span {
  font-size: 0.8rem;
}
@media screen and (min-width: 992px) {
  .ios.platform-cordova .jackpot-counter span {
    font-size: 0.8rem;
  }
}

.ipadJackpot {
  position: absolute;
  z-index: 998;
  background: rgba(0, 0, 0, 0.6);
  text-align: center;
  max-width: 100% !important;
  padding: 0 4px 2px;
}
.ipadJackpot span {
  color: #FFF;
  font-size: 1.4rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/mobile/jackpot-counter-mobile/jackpot-counter-mobile.component.scss"],"names":[],"mappings":"AACI;EACE,0BAAA;EACA,mBAAA;EACA,kBAAA;AAAN;AAEM;EACE,iBAAA;AAAR;AAEQ;EAHF;IAII,iBAAA;EACR;AACF;;AAIE;EACE,kBAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;AADJ;AAGI;EACE,WAAA;EACA,iBAAA;AADN","sourcesContent":[".ios.platform-cordova {\n    .jackpot-counter {\n      border-radius: 4px 4px 0 0;\n      line-height: 0.5rem;\n      padding: 0 1px 2px;\n  \n      span {\n        font-size: 0.8rem;\n  \n        @media screen and (min-width: 992px) {\n          font-size: 0.8rem;\n        }\n      }\n    }\n  }\n  \n  .ipadJackpot {\n    position: absolute;\n    z-index: 998;\n    background: rgba(0, 0, 0, 0.6);\n    text-align: center;\n    max-width: 100% !important;\n    padding: 0 4px 2px;\n  \n    span {\n      color:#FFF;\n      font-size: 1.4rem;\n    }\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
